import { ShipmentDetailsRequestModel } from "api/lokiRequestModels/shipments/ShipmentDetailsRequestModel";
import { LynxTable } from "components/LynxTable/LynxTable";
import { dateEndFormatting, dateStartFormatting } from "helpers/dateFormatting";
import { observer } from "mobx-react";
import { useStore } from "store/StoreConfigs";
import { useParams } from "react-router-dom";
import { laneViewShipmentsTableColumns } from "./LaneViewShipmentsTableColumns";

export const LaneViewShipmentsTableWrapper = observer(function TableWrapper() {
    const { laneStore, filtersStore, identityStore } = useStore();
    const { laneId } = useParams<any>();

    const onSortChange = (id: string, sortDirection: "ASC" | "DESC") => {
        laneStore.setShipmentSortProperty(id);
        laneStore.setShipmentDirection(sortDirection);
    };

    const onPageChange = (direction: "back" | "forward") => {
        if (direction === "back") {
            laneStore.moveToPreviousShipmentsPage();
        } else {
            const request: ShipmentDetailsRequestModel = {
                startTime: dateStartFormatting(filtersStore.startDate),
                endTime: dateEndFormatting(filtersStore.endDate),
                laneId,
                customerId: identityStore.currentCustomerId,
                lsp: filtersStore.selectedLogisticsServiceProviders.join(",") || undefined,
                productType: filtersStore.selectedProductTypes.join(",") || undefined,
                riskLevel: filtersStore.selectRiskLevels.join(",") || undefined,
                transportationModes: filtersStore.selectedModesOfTransportation.join(",") || undefined,
                packagingType: filtersStore.selectedPackagingTypes.join(",") || undefined,
                nextToken: laneStore.shipmentNextToken,
                sort: laneStore.sortShipment,
                direction: laneStore.directionShipment,
            };
            laneStore.moveToNextShipmentPage(request);
        }
    };

    return (
        <LynxTable
            columns={laneViewShipmentsTableColumns}
            rows={
                laneStore.shipmentPages.length === 0 ? [] : laneStore.shipmentPages[laneStore.currentShipmentPage - 1]
            }
            rowKey="shipmentId"
            page={laneStore.currentShipmentPage}
            isLastPage={laneStore.isLastShipmentPage}
            onPageChange={onPageChange}
            sortedBy={laneStore.sortShipment}
            sortDirection={laneStore.directionShipment}
            onSortChange={onSortChange}
            isLoading={laneStore.loadingShipments}
        />
    );
});
